module.exports = __webpack_public_path__ + "static/media/pdf.f7221167.svg";